import dayjs from 'dayjs'
import Module from '../Module';
import QueryParam from '../QueryParam';

export default class TraveldateOffer extends Module {
    constructor(title, index, offers, firstQuestion, checkin, checkout, minNights = 0, stepsSlugToTitle) {
        // Chain constructor with super
        super(title, index, 'traveldateoffer', firstQuestion);
        this._defaultText = null;
        this._title = title || 'Auswahl & Reisedatum';
        this._firstQuestion = firstQuestion || 'Welchen Wunsch haben Sie?';
        this._offers = offers;
        this._minNights = minNights;
        const hasOffers = this._offers && this._offers.length;
        this._setPresetDatesFromConfigOrQueryParams({
            checkin: checkin,
            checkout: checkout,
        })
        this._checkin = '';
        this._checkout = '';
        this._text = this._defaultText;
        this._duration = '';
        this._duration_value = null;
        this._message = '';
        this._anfrage_type = this.determineAnfrageTyp(stepsSlugToTitle)
        this._selectedOffer = '';

        const preSelectedOffer = QueryParam.getQueryVariable('buchung');
        if (hasOffers && preSelectedOffer && preSelectedOffer.length) {
            const matchingOffer = this._offers.find(function(value, idx) {
                return value.url.match(preSelectedOffer);
            });
            if (matchingOffer) {
                this._selectedOffer = matchingOffer.title;
                this._anfrage_type = 'Angebot auswählen'
            }
        }
    }

    get minNights() {
        return this._minNights;
    }

    set minNights(value) {
        this._minNights = value;
    }

    get durationValue() {
        return this._duration_value;
    }

    set durationValue(value) {
        this._duration_value = value;
    }
    get selectedOffer() {
        return this._selectedOffer;
    }

    set selectedOffer(selectedOffer) {
        this._selectedOffer = selectedOffer;
    }

    get anfrage_type() {
        return this._anfrage_type;
    }

    set anfrage_type(anfrage_type) {
        this._anfrage_type = anfrage_type;
    }

    get message() {
        return this._message;
    }

    set message(message) {
        this._message = message;
    }

    get checkin() {
        return this._checkin;
    }

    set checkin(checkin) {
        this._checkin = checkin;
    }

    get checkout() {
        return this._checkout;
    }

    set checkout(checkout) {
        this._checkout = checkout;
    }

    get text() {
        return this._text;
    }

    set text(text) {
        this._text = text;
    }

    get duration() {
        return this._duration;
    }

    set duration(duration) {
        this._duration = duration;
    }

    get offers() {
        return this._offers;
    }

    updatePicker(start, end, state, reset) {
        if (reset) {
            this.checkin = '';
            this.checkout = '';
            this.text = this._defaultText;
            this.duration = '';
            return false;
        }
        let startMoment = null
        let endMoment = null

        if (start?.length > 0) {
            startMoment = dayjs(start).startOf('day')
            this.checkin = startMoment.format('YYYY-MM-DD');
        }

        if (end?.length > 0) {
            endMoment = dayjs(end).startOf('day')
            this.checkout = endMoment.format('YYYY-MM-DD');
        }

        if (startMoment?.isValid() && endMoment?.isValid()) {
            this.text = startMoment.format('DD.MM.YYYY') + ' - ' + endMoment.format('DD.MM.YYYY');
            const duration = endMoment.diff(startMoment, 'day')
            const durationString = ' = ' + duration + ' ' + (duration === 1 ? state.i18n.night : state.i18n.nights);
            this.duration = durationString;
            this.durationValue = duration
        }
    }

    /* either take it from config.checkin / config.checkout or GET param checkin, checkout */
    tryToPresetDates(store) {
        const checkin = this._presetDates.checkin;
        const checkout = this._presetDates.checkout;
        if (checkin && checkout) {
            this.setDates(store, checkin, checkout);
        }
    }

    fillDummyData(store) {
        const checkin = dayjs().format('ddd, DD MMM YYYY HH:mm:ss ZZ');
        const checkout = dayjs().add(Math.floor(Math.random() * 21) + 1, 'days').format('ddd, DD MMM YYYY HH:mm:ss ZZ');
        this.setDates(store, checkin, checkout);
        this.anfrage_type = 'Übernachtung';
    }

    setDates(store, checkin, checkout) {
        this.checkin = checkin;
        this.checkout = checkout;
        this.updatePicker(checkin, checkout, store.state);
        store.commit('updateUserInput', {name: this.fieldName('checkin'), module: this.type, input: this.checkin});
        store.commit('updateUserInput', {name: this.fieldName('checkout'), module: this.type, input: this.checkout});
    }

    removeDummyData() {
        this.updatePicker(null, null, null, true);
        this.anfrage_type = null;
    }

    determineAnfrageTyp(stepsSlugToTitle){
        const externalValue = QueryParam.getQueryVariable('anfrage_typ')
        if (!externalValue) {
            return
        }

        return stepsSlugToTitle[externalValue] || externalValue
    }
}